import { render } from "./EntriesFilterBar.vue?vue&type=template&id=2d0fa66d"
import script from "./EntriesFilterBar.vue?vue&type=script&lang=js"
export * from "./EntriesFilterBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__